import { Injectable } from '@angular/core';
import  Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  constructor() { }

  homeFireSuccessSwal(message: string){
      return Swal.fire({
      title: message,
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }
  fireSuccessSwal(message: string, protocolo:string){
      return Swal.fire({
      title: message,
      text: protocolo,
      icon: 'success',
      confirmButtonText: 'OK',
      confirmButtonColor: 'var(--main-blue)',
      allowEscapeKey:false,
      allowOutsideClick:false
    })
  }
  fireErrorSwal(title:string, message: string){
      return Swal.fire({
      title: title,
      text: message,
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: 'var(--main-blue)',

    })
  }

  avisoRecessoSwal() {
    const inicioRecesso = new Date('2024-12-23T00:00:00');
    const fimRecesso = new Date('2025-01-05T23:59:59');
    const dataAtual = new Date();

    if(dataAtual < inicioRecesso) {
      return Swal.fire({
        title: 'Aviso de Recesso',
        html: '<p style="text-align: justify;">Olá, <br> Estaremos em recesso entre os dias <strong>23/12/2024</strong> e <strong>05/01/2025</strong>, retornando dia <strong>06/01/2025</strong>.</p>',
        icon: 'info',
        confirmButtonText: 'Entendi',
        background: '#f8f9fa',
        color: '#212529',
        confirmButtonColor: '#064A72'
      });
    } else if (dataAtual <= fimRecesso) {
        return Swal.fire({
          title: 'Aviso de Recesso',
          html: '<p style="text-align: justify;">Olá, <br> Estamos em recesso entre os dias <strong>23/12/2024</strong> e <strong>05/01/2025</strong>, retornando dia <strong>06/01/2025</strong>.</p>',
          icon: 'info',
          confirmButtonText: 'Entendi',
          background: '#f8f9fa',
          color: '#212529',
          confirmButtonColor: '#064A72'
        });
    }
    return;
  }
}
